import React from 'react';
import { makeStyles, Card, Grid } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

import LooksOneIcon from '@material-ui/icons/LooksOne';
import LooksTwoIcon from '@material-ui/icons/LooksTwo';
import Looks3Icon from '@material-ui/icons/Looks3';

const useStyles = makeStyles((theme) => ({
  card: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center'
  },
  tab: {
    paddingBottom: 15,
    paddingRight: 16,
    paddingLeft: 16,
    marginTop: 16,
    color: theme.palette.neutrals.low.light,
    fontSize: 14,
    fontWeight: 600,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  active: {
    borderBottom: `2px solid ${theme.palette.primary.main}`,
    color: theme.palette.primary.main,
  },
  icon: {
    fontSize: 18,
    color: theme.palette.neutrals.low.light,
    marginRight: 11
  },
  activeIcon: {
    color: theme.palette.primary.main,
  },
}));

function CurationMenusTable({ handleChangeTab, tabChosed }) {
  const classes = useStyles();
  // const location = useLocation();

  const { t } = useTranslation();

  return (
    <Card elevation={0} className={classes.card}>
      <Grid container xs={12}>
        <Grid item xs={4}
          onClick={() => handleChangeTab('AWAITING_QUALIFICATION')}
          className={
            tabChosed === 'AWAITING_QUALIFICATION'
              // location.pathname === `/curation-ideas-mat`
              ? clsx(classes.tab, classes.active)
              : classes.tab
          }
        >
          <LooksOneIcon className={
            tabChosed === 'AWAITING_QUALIFICATION'
              ? clsx(classes.icon, classes.activeIcon)
              : classes.icon
          }
          />
          {t('qualificar')}
        </Grid>
        <Grid item xs={4}
          onClick={() => handleChangeTab('EXECUTION_QUEUE')}
          className={
            tabChosed === 'EXECUTION_QUEUE'
              ? clsx(classes.tab, classes.active)
              : classes.tab
          }
        >
          <LooksTwoIcon className={
            tabChosed === 'EXECUTION_QUEUE'
              ? clsx(classes.icon, classes.activeIcon)
              : classes.icon
          }
          />
          {t('planejar_execucao')}
        </Grid>
        <Grid item xs={4}
          onClick={() => handleChangeTab('EXECUTING')}
          className={
            tabChosed === 'EXECUTING'
              ? clsx(classes.tab, classes.active)
              : classes.tab
          }
        >
          <Looks3Icon className={
            tabChosed === 'EXECUTING'
              ? clsx(classes.icon, classes.activeIcon)
              : classes.icon
          }
          />
          {t('concluir_execucao')}
        </Grid>
      </Grid>
    </Card>
  );
}

export { CurationMenusTable };
